import { createAction } from 'typesafe-actions';
import { Settings } from '../../../app/data/types/game/settings';
import { INIT_SETTINGS, TOGGLE_AUTO_IGNORE } from './settings.action-types';
import { ActorType } from '../../../app/data/interaction/actor-type';

export const initSettings = createAction(INIT_SETTINGS)<Settings>();
export const toggleAutoIgnore = createAction(TOGGLE_AUTO_IGNORE)<ActorType>();
